export class TrackingConstants {
  static postTrackingInterval = 3000;
  static idleInteractionInterval = 15000;
  static topBarHeight = 72;
}
